// @flow
import {
    type Action as SearchTermActions,
    type SearchTermType
} from '../actions/searchTerm';
import type {Action as SearchQueryAction} from '../actions/searchQuery';

export type State = $Shape<SearchTermType>;

const initialState = {};

export default function reducer(
    state: State = initialState,
    action: SearchTermActions | SearchQueryAction
): State {
    switch (action.type) {
        case 'SEARCH_TERM/INIT':
            return {...state, ...action.payload};
        case 'SEARCH_QUERY/COMPLETE':
            if (
                action.payload &&
                action.payload.results &&
                action.payload.results.searchTerm
            ) {
                const {searchTerm} = action.payload.results;
                return {
                    ...state,
                    description: searchTerm.description,
                    id: searchTerm.termId
                };
            }
            return state;
        default:
            (action: empty); // eslint-disable-line no-unused-expressions
            return state;
    }
}
